import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../images/Logo-Transparent-Horizontal.jpg';
import './Header.scss';
import Routes from '../../constants/routes';

class CustomerHeader extends React.Component {
    constructor(props, context) {
        super(props, context);

    }

    // this will turn into something more when Rich creates the story for it
    render() {

        return (
            <div>
                <nav className='navbar navbar-expand-lg navbar-dark'>
                    <NavLink className="navbar-brand" exact to={Routes.Root}>
                        <div className="navbar-logo-wrapper">
                            {
                                logo &&
                                <img src={logo} alt="Home" />
                            }
                        </div>
                    </NavLink>
                    <ul className="navbar-nav mr-auto">
                        <div className="app-link">
                            <div className="app-link-item">
                                <NavLink className="" to={Routes.DashboardEhAdmin}>Dashboard</NavLink>
                            </div>
                        </div>
                        <div className="app-link">
                            <div className="app-link-item">
                                <NavLink className="" to={Routes.CrossSubscriptionSearch}>Global Users</NavLink>
                            </div>
                        </div>                        
                        <div className="app-link">
                            <div className="app-link-item">
                                <NavLink className="" to={Routes.ToolTips}>Tool Tips</NavLink>
                            </div>
                        </div>
                        <div className="app-link">
                            <div className="app-link-item">
                                <NavLink className="" to={Routes.WebAssets}>Web Assets</NavLink>
                            </div>
                        </div>
                    </ul>
                    <ul className="navbar-nav">
                        <div className="app-link">
                            <div className="app-link-item">
                                <NavLink className="" to={Routes.LoginPage}>Logout</NavLink>
                            </div>
                        </div>
                    </ul>
                </nav>
            </div>

        );
    }

}

export default CustomerHeader;
